import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';
import { NavLink } from 'react-router-dom';

const StyledBlogLink = styled(NavLink)`
  position: relative;
  display: block;
  color: ${ds.brand('text')};
  font-size: ${ds.fontSize('s')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.regular')};
  text-decoration:none;
  padding: ${ds.get('metrics.xs')} 0 ${ds.get('metrics.xs')} 0;

  &.active {
    font-weight: ${ds.get('type.fontWeight.bold')};
  }

  ${media.desktop`
      padding: calc(${ds.get('metrics.xs')} / 2) calc(${ds.get('metrics.xs')} * 2);
  `}
`;

export default StyledBlogLink;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MainNavigation/StyledBlogLink.jsx